<template>
  <b-tabs content-class="mt-3">
    <b-tab title="İçerik" active>
      <Icerik
        :updateData="updateData"
        :kategoriler="kategoriler"
        @show="$emit('show', $event)"
        @updateRefresh="$emit('updateRefresh', $event)"
        @handlerClose="$emit('handlerClose', $event)"
      />
    </b-tab>
    <b-tab title="Fotoğraflar">
      <Fotograflar :updateData="updateData" />
    </b-tab>
  </b-tabs>
</template>

<script>
import vSelect from 'vue-select';
import { defineComponent, ref, computed } from '@vue/composition-api';
import store from '@/store';
import Icerik from './TheIcerik.vue';
import Fotograflar from './TheFotograflar.vue';
export default defineComponent({
  components: {
    vSelect,
    Icerik,
    Fotograflar,
  },
  props: {
    updateData: {
      type: Object,
      required: false,
    },
  },
  setup() {
    const expo = {};
    expo.defaultDil = ref(store.getters.getDilAyarlari.varsayilan);
    expo.kategoriler = ref([]);
    expo.kategoriler = computed(() => {
      let kategoriler = [];
      const kat = store.getters.getKategoriler.filter((x) => x.kategori_k_no == null);

      kat.forEach((el) => {
        kategoriler.push({ k_no: el.k_no, baslik: el.icerik[expo.defaultDil.value].baslik });
      });

      return kategoriler;
    });

    return { ...expo };
  },
});
</script>

<style lang="scss"></style>
